import classNames from "classnames";
import React from "react";
import { useComponentState } from "../../utils/customHook.util";
import { PictogramIcon } from "../Common/Icon";
import "./ExternalImageSelect.css";

type ExternalImageSelect = {
    allUrls: string[];
    initialUrlSelections: string[];
    onSelect: (selectedUrls: string[]) => void;
};

type ExternalImageSelectState = {
    selectedImages: string[];
};

function ExternalImageSelect(props: ExternalImageSelect) {
    const { allUrls, initialUrlSelections, onSelect } = props;
    const { state, setState } = useComponentState<ExternalImageSelectState>({
        selectedImages: initialUrlSelections,
    });

    return (
        <div className="external-image-select__thumbnails">
            {(allUrls || []).map((url) => {
                const isSelected = state.selectedImages.includes(url);

                return (
                    <div
                        key={url}
                        className={classNames("external-image-select__thumbnail", {
                            "external-image-select__thumbnail--selected": isSelected,
                        })}
                        onClick={() => {
                            const selected = state.selectedImages.includes(url)
                                ? state.selectedImages.filter((it) => it !== url)
                                : [...state.selectedImages, url];

                            setState({ selectedImages: selected });
                            onSelect(selected);
                        }}
                    >
                        <img
                            className="external-image-select__thumbnail-image"
                            key={url}
                            src={url}
                            alt=""
                        />
                        {isSelected && <PictogramIcon.Check.Small.P90 />}
                    </div>
                );
            })}
        </div>
    );
}

export default ExternalImageSelect;
